(function (){
    function initSlidepanel() {
        var slidepanel = document.getElementById('slidepanel');
        var io = new IntersectionObserver(function(entries, io){
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    slidepanel.classList.add('open');
                } else {
                    slidepanel.classList.remove('open');
                }
            });
        });
        io.observe(document.getElementById('slidepanel-trigger'));

        slidepanel.querySelector('.close').addEventListener('click', function(){
            io.disconnect();
            slidepanel.remove();
        });
    }

    if (document.readyState == 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initSlidepanel();
        });
    } else {
        initSlidepanel();
    }
})();